// @core/api/endpoints/authn/resend_verification_email.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ResendVerificationEmailRequest,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Resend email verification link
 * Resends the email verification link to the user's registered email address. Invalidates any previously sent verification tokens and generates a new one.
 */
export async function ResendVerificationEmail(
  data: ResendVerificationEmailRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/auth/email/verification/resend`;
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
